"use client";

import { AlertCircle, RefreshCcw } from "lucide-react";
import {
  ErrorBoundary as ReactErrorBoundary,
  type FallbackProps,
} from "react-error-boundary";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";

function Fallback({ error, resetErrorBoundary }: FallbackProps) {
  const message = error instanceof Error ? error.message : null;
  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md rounded-lg border border-border-default bg-bg-card p-6 shadow-sm">
        <div className="flex items-start gap-3">
          <AlertCircle className="size-5 shrink-0 text-error" />
          <div className="flex-1 space-y-2">
            <h1 className="font-display text-lg font-semibold">
              Beklenmeyen bir hata oluştu
            </h1>
            <p className="text-sm text-text-secondary">
              CMS bu sayfada bir sorunla karşılaştı. Tekrar denemek için aşağıdaki
              butona basabilir veya konsolu açıp detaya bakabilirsin.
            </p>
            {message ? (
              <pre className="mt-2 max-h-40 overflow-auto rounded bg-bg-subtle p-3 font-mono text-xs text-text-tertiary">
                {message}
              </pre>
            ) : null}
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button onClick={resetErrorBoundary} variant="default">
            <RefreshCcw className="mr-2 size-4" />
            Yeniden dene
          </Button>
        </div>
      </div>
    </div>
  );
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return <ReactErrorBoundary FallbackComponent={Fallback}>{children}</ReactErrorBoundary>;
}
